import { useMemo } from "react";
import { maxBy } from 'lodash';

const DEFAULT_SCALE = 1;
export const LARGE_VARIANT_CONFIG = {
    baselineCharCount: 10,
    baseFontSize: 7.55, // 145px
    baseLineHeight: 8.3, // 159.50px
}

interface UsePosterTextConfig {
    baselineCharCount: number,
    baseFontSize: number,
    baseLineHeight: number,
}

interface UsePosterTitle {
    scaleCoefficient: number,
    fontSize: number,
    lineHeight: number,
}

export const usePosterTitle = (
    title: string | null,
    config: UsePosterTextConfig = LARGE_VARIANT_CONFIG
): UsePosterTitle => {
    const {
        baselineCharCount,
        baseFontSize,
        baseLineHeight,
    } = config;

    return useMemo(() => {
        if (!title) {
            return {
                scaleCoefficient: DEFAULT_SCALE,
                fontSize: LARGE_VARIANT_CONFIG.baseFontSize,
                lineHeight: LARGE_VARIANT_CONFIG.baseLineHeight,
            };
        }

        const lines = title.split('\n');
        const longestLine = maxBy(lines, 'length');
        const longestLineLength = longestLine.length;

        const scaleCoefficient =  longestLineLength > baselineCharCount ? baselineCharCount / longestLineLength : DEFAULT_SCALE;
        return {
            scaleCoefficient,
            fontSize: baseFontSize * scaleCoefficient,
            lineHeight: baseLineHeight * scaleCoefficient,
        };
    }, [baselineCharCount, baseFontSize])
}
